import { Grid } from '@material-ui/core';
import PropTypes from 'prop-types';
import { withProps } from '../../utils';

const GridItem = withProps({ item: true }, Grid);

GridItem.propTypes = {
  children : PropTypes.node.isRequired,
  className: PropTypes.string,
};

GridItem.defaultProps = {
  className: '',
};

export default GridItem;
